import { render, staticRenderFns } from "./LogoHeader.vue?vue&type=template&id=1e84828c&scoped=true&"
import script from "./LogoHeader.vue?vue&type=script&lang=js&"
export * from "./LogoHeader.vue?vue&type=script&lang=js&"
import style0 from "./LogoHeader.vue?vue&type=style&index=0&id=1e84828c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e84828c",
  null
  
)

export default component.exports